import apiClient from 'api/client';
import md5 from 'crypto-js/md5';
import { clearStoredUser, logoutIfUnauthorized, redirectIfSessionMissing } from 'api/session';

var apiUrl = process.env.REACT_APP_API_URL;

export const userService = {
    login,
    refreshToken,
    logout,
    logoutUnauthorized,
    register,
    getAll,
    getById,
    update,
    delete: _delete
};

function login(username, password) {
    password = md5(password).toString();
    const requestBody = { authenticate: { username, password } };

    return apiClient.post(`${apiUrl}/Authentication`, requestBody, {
        headers: { 'Content-Type': 'application/json' }
    })
        .then(handleResponse)
        .catch(handleError)
        .then(user => {
            if (user.token) {
                localStorage.setItem('user', JSON.stringify(user));
            }

            return user;
        });
}

function refreshToken(username, token) {
    const requestBody = {
        authenticate: {
            username,
            token,
            type: 'refresh'
        }
    };

    return apiClient.post(`${apiUrl}/Authentication`, requestBody, {
        headers: { 'Content-Type': 'application/json' }
    })
        .then(handleResponse)
        .catch(handleError)
        .then(user => {
            if (user.token) {
                localStorage.setItem('user', JSON.stringify(user));
            }

            return user;
        });
}

function logout() {
    clearStoredUser();
}

function logoutUnauthorized(source) {
    if (logoutIfUnauthorized(source)) {
        return true;
    }

    if (!source) {
        return redirectIfSessionMissing();
    }

    return false;
}

function getAll() {
    return apiClient.get(`${apiUrl}/Authentication`).then(handleResponse).catch(handleError);
}

function getById(id) {
    return apiClient.get(`${apiUrl}/Authentication/${id}`).then(handleResponse).catch(handleError);
}

function register(user) {
    return apiClient.post(`${apiUrl}/Authentication/register`, user, {
        headers: { 'Content-Type': 'application/json' }
    }).then(handleResponse).catch(handleError);
}

function update(user) {
    //console.log("****update");
    // const requestOptions = {
    //     method: 'PUT',
    //     headers: { ...authHeader(), 'Content-Type': 'application/json' },
    //     body: JSON.stringify(user)
    // };
    //
    // return fetch(`${apiUrl}/Authentication/${user.id}`, requestOptions).then(handleResponse);;
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    return apiClient.delete(`${apiUrl}/Authentication/${id}`).then(handleResponse).catch(handleError);
}

function handleResponse(response) {
    return response.data;
}

function handleError(error) {
    const data = error && error.response ? error.response.data : null;
    const message = (data && data.message) || (error && error.response ? error.response.statusText : null) || error.message;

    return Promise.reject(message);
}
